import { render, staticRenderFns } from "./ScheduleWishes.vue?vue&type=template&id=65f0bad6&"
import script from "./scheduleWishes.js?vue&type=script&lang=js&"
export * from "./scheduleWishes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports